function BagIcon() {
  return <img src="/bagIcon.svg" alt="bagIcon" width="24px" height="24px" />
}

export default BagIcon
